import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-8 pb-12 md:pt-20 md:pb-32 overflow-hidden bg-cream-white" data-id="element-53">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-54">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-warm-beige/50 blur-3xl" data-id="element-55" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full bg-soft-pink/30 blur-3xl" data-id="element-56" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-57">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 items-center" data-id="element-58">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex flex-col items-start text-left" data-id="element-59">
            <span className="inline-block py-1 px-3 rounded-full bg-sage-green/20 text-sage-green font-semibold text-sm mb-3 md:mb-6 tracking-wide uppercase" data-id="element-60">
              El Sistema Definitivo
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-deep-charcoal leading-tight mb-4 md:mb-6" data-id="element-61">
              No es falta de voluntad. Es tu Cortisol bloqueando tu pérdida de
              grasa cada 28 días.
            </h1>
            <p className="text-base md:text-xl text-deep-charcoal/80 mb-5 md:mb-8 leading-relaxed" data-id="element-62">
              Deja de luchar contra tu cuerpo y empieza a sincronizar tu
              metabolismo con tus 4 fases hormonales. Recupera tu energía,
              elimina el hinchazón y domina tu peso de forma natural.
            </p>

            {/* Product mockup above the button */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.3,
            ease: 'easeOut'
          }} className="relative w-full mb-5 md:mb-8 rounded-2xl overflow-hidden shadow-xl aspect-[4/3] bg-warm-beige md:hidden" data-id="element-63">
              <img src="https://cdn.magicpatterns.com/uploads/iag9TmkkPqHt9rfpmjUPTT/mk-2.png" alt="El Código Hormonal 28D en un iPad con elementos 3D" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-64" />
            </motion.div>

            <button onClick={scrollToPricing} className="group relative inline-flex items-center justify-center px-8 py-4 text-base font-bold text-white transition-all duration-200 bg-dusty-rose border border-transparent rounded-full hover:bg-dusty-rose/90 hover:shadow-lg hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-dusty-rose w-full sm:w-auto" data-id="element-65">
              QUIERO MI PACK CÓDIGO HORMONAL AHORA
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-66" />
            </button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative hidden md:block" data-id="element-67">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/5] md:aspect-auto md:h-[600px] w-full bg-warm-beige" data-id="element-68">
              <img src="https://cdn.magicpatterns.com/uploads/iag9TmkkPqHt9rfpmjUPTT/mk-2.png" alt="El Código Hormonal 28D en un iPad con elementos 3D" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-69" />
            </div>

            {/* Floating badge */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 1,
            duration: 0.6
          }} className="absolute -bottom-6 -left-6 md:-left-12 bg-white p-4 rounded-xl shadow-xl flex items-center gap-4 border border-warm-beige" data-id="element-70">
              <div className="w-12 h-12 rounded-full bg-soft-pink flex items-center justify-center text-dusty-rose font-bold text-xl" data-id="element-71">
                28
              </div>
              <div data-id="element-72">
                <p className="text-sm font-bold text-deep-charcoal" data-id="element-73">
                  Días para
                </p>
                <p className="text-xs text-deep-charcoal/70" data-id="element-74">
                  transformar tu cuerpo
                </p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}